import {BaseContainerModel} from '../../base-container.model';
import {
  bl_aat_claim_account_employee_topup_event_RowClass,
} from '../../../dbschema';

export class ClaimAccountEmployeeTopupEventContainerModel extends BaseContainerModel {
  bl_aat_claim_account_employee_topup_event: bl_aat_claim_account_employee_topup_event_RowClass = new bl_aat_claim_account_employee_topup_event_RowClass();
}
